/* eslint-disable eqeqeq */

const prefix = {
  "CB": "CB",
  "SB": "SB",
  "ACB": "ACB",
  "SS": "SS"
};

export const ResolvePrefix = (prefixString: keyof typeof prefix): string => {
  return prefix[prefixString];
};

const CheckReschedule = (dateString: string) => {
  const date = new Date(dateString);

  const currentDate = new Date();

  const diffInMinutes = Math.floor(
    (date.getTime() - currentDate.getTime()) / (1000 * 60)
  );

  return diffInMinutes < 60;
};

const LableFromEnums = (key: string, data: any) => {
  for (const obj in data) {
    if (Object.prototype.hasOwnProperty.call(data, obj)) {
      const values = data[obj];
      if (key in values) {
        return values[key];
      }
    }
  }
  return key;
};

export const validateCharacterLength = (value = "", min = 0, max = 0) => {
  if (!value) {
    return true;
  }

  if (value?.length < min) {
    return false;
  }

  if (value?.length > max) {
    return false;
  }

  return true;
};

export const validateSpecialCharacter = (value = "") => {
  if (!value) {
    return true;
  }

  return /^[A-Za-z\s,.&-]*$/.test(value);
};
export const validateAlphabet = (value = "") => {
  if (!value) {
    return true;
  }

  return /^[A-Za-z\s]*$/.test(value);
};

export const validateAlphanumericCharacter = (value = "") => {
  if (!value) {
    return true;
  }

  return /^[A-Za-z][A-Za-z0-9\s,.!&-]*$/.test(value);
};

export const validateAlphanumericCharacterWithoutSequence = (value = "") => {
  if (!value) {
    return true;
  }

  return /^[A-Za-z0-9\s,.&-]*$/.test(value);
};

export const validatePositiveValue = (value = "", type: string = "float") => {
  if (!value) {
    return true;
  }



  if (value.includes("-")) {
    return false;
  }

  if (value.includes("+")) {
    return false;
  }

  if (Number.isNaN(value)) {
    return false;
  }

  return Number(value) > 0;
};

export const CurrentDate = new Date();
export const CurrentMonth =
  CurrentDate.getMonth() + 1 < 10
    ? `0${CurrentDate.getMonth() + 1}`
    : `${CurrentDate.getMonth() + 1}`;
export const CurrentYear = `${CurrentDate.getFullYear()}`;

export const handleIgstChange = (
  e: any,
  setIgst: any,
  setCgst: any,
  setSgst: any
) => {
  const IGST = Number(e?.target?.value);
  if (IGST >= 0 && IGST <= 100) {
    setIgst(IGST);
    setCgst((IGST / 2).toFixed(2));
    setSgst((IGST / 2).toFixed(2));
  }
};

export const handleCgstChange = (
  e: any,
  setIgst: any,
  setCgst: any,
  sgst: any
) => {
  let CGST: any = e?.target?.value;

  if (CGST == "") {
    CGST = 0;
  }
  if (sgst == "") {
    sgst = 0;
  }
  const IGST = parseFloat(CGST) + parseFloat(sgst);

  if (IGST >= 0 && IGST <= 100 && CGST >= 0) {
    setIgst(IGST.toFixed(2));
    setCgst(CGST.toFixed(2));
  }
};

export const handleSgstChange = (
  e: any,
  setIgst: any,
  cgst: any,
  setSgst: any
) => {
  let SGST = e?.target?.value;
  if (cgst == "") {
    cgst = 0;
  }
  if (SGST == "") {
    SGST = 0;
  }
  const IGST = parseFloat(cgst) + parseFloat(SGST);
  if (IGST >= 0 && IGST <= 100 && SGST >= 0) {
    setIgst(IGST.toFixed(2));
    setSgst(SGST.toFixed(2));
  }
};

export const getPercentValue = (amount: number, percent: number) => {
  return (Number(amount) * Number(percent)) / 100;
};

export { CheckReschedule, LableFromEnums };

export const getLastDate = (startDate: Date, numberOfWeeks: number): Date => {
  const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000;
  const endDate = new Date(
    startDate.getTime() + numberOfWeeks * millisecondsPerWeek
  );
  return new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate() - 1
  );
};

export const emailValidation = (email: string) => {
  return email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/);
};
export const nameValidation = (name: string) => {
  return name.match(/^[a-zA-Z .-]+$/);
};
export const nameValidation2 = (name: string) => {
  return name.match(/^[a-zA-Z0-9\s\-\.@(),/&#]*$/);
};

export const nameWithNumberValidation = (name: string) => {
  return name.match(/^[a-zA-Z0-9 -.]+$/);
};

export const numberValidation = (data: any) => {
  return String(data).match(/^\d*(\.\d{0,2})?$/);
};

export const WEEK_DAYS: any = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const dayOrder = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const TIME_OPTIONS = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];



export const Days = [
  {
    value: "Monday",
    labelKey: "Monday",
  },
  {
    value: "Tuesday",
    labelKey: "Tuesday",
  },
  {
    value: "Wednesday",
    labelKey: "Wednesday",
  },
  {
    value: "Thursday",
    labelKey: "Thursday",
  },
  {
    value: "Friday",
    labelKey: "Friday",
  },
  {
    value: "Saturday",
    labelKey: "Saturday",
  },
  {
    value: "Sunday",
    labelKey: "Sunday",
  },
];
